import React, { createContext, useContext, useEffect, useState } from "react";

const CartCtx = createContext(null);
const KEY = "playa_cart";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
  });

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);

  const add = (product, quantity = 1) => {
    setItems((cur) => {
      const existing = cur.find((it) => it.product_id === product.id);
      if (existing) {
        return cur.map((it) => it.product_id === product.id ? { ...it, quantity: it.quantity + quantity } : it);
      }
      return [...cur, {
        product_id: product.id,
        slug: product.slug,
        name: product.name,
        price: product.sale_price || product.price,
        image: product.images?.[0],
        quantity,
      }];
    });
  };

  const remove = (product_id) => setItems((cur) => cur.filter((it) => it.product_id !== product_id));
  const updateQty = (product_id, quantity) => setItems((cur) => cur.map((it) => it.product_id === product_id ? { ...it, quantity } : it));
  const clear = () => setItems([]);
  const subtotal = items.reduce((s, it) => s + it.price * it.quantity, 0);
  const count = items.reduce((s, it) => s + it.quantity, 0);

  return (
    <CartCtx.Provider value={{ items, add, remove, updateQty, clear, subtotal, count }}>
      {children}
    </CartCtx.Provider>
  );
}

export const useCart = () => useContext(CartCtx);
